import gsap from 'gsap'

import { SharedAnimation, titleRevealAnimation } from './shared'
import { Animation } from '@/types'

export const heroAnimation = ({
  node,
  nodeRef,
  reverse,
  context,
  delay
}: Animation) => {
  const selector =
    context?.selector || gsap.utils.selector(nodeRef?.current || node)

  const headline = selector('[data-motion-headline]')[0]

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger,
    delay
  })

  const contentTimeline = gsap.timeline()

  let titleAnimation: SharedAnimation
  if (headline) {
    titleAnimation = titleRevealAnimation(headline, reverse)
    contentTimeline.add(titleAnimation.timeline, '<+0.1')
  }

  timeline.add(contentTimeline, '<+0.3')

  return () => {
    if (titleAnimation) {
      titleAnimation.revert()
    }
  }
}
